import React from 'react'
import { Modal, Header, Button } from 'semantic-ui-react'
import { TwitterTweetEmbed } from 'react-twitter-embed'

const WhySubscribeModal = () => {
  const [whyOpen, setWhyOpen] = React.useState(false)

  return (
    <>
      <p>
        Subscribe now to start getting alerts on products that might affect you.
      </p>
      <Modal
        trigger={
          <a
            href=""
            onClick={e => {
              e.preventDefault()
              setWhyOpen(true)
            }}
          >
            Why subscribe?
          </a>
        }
        size="large"
        closeIcon
        open={whyOpen}
        onClose={() => setWhyOpen(false)}
        css={{
          maxWidth: '30rem !important',
        }}
      >
        <Header content="Why subscribe?" />
        <Modal.Content scrolling>
          <p>
            Recall Monitor is an independent product here to help spread the
            word about recalled products to Canadians. Every year hundreds of
            products are recalled, and most people are not aware of risks they
            take daily.
          </p>
          <p>
            Media outlets and social media are very ineffective and slow ways of
            learning about recalls. Sometimes it might even take months to learn
            about a recall that applies to you.
          </p>
          <p>
            Take this member for example, who got a mail from Subaru about the
            safety recall on their car <strong>2 months</strong> after being
            notified by Recall Monitor.
          </p>
          <TwitterTweetEmbed tweetId={'1208154580657131521'} />
          <p>
            Are you sure the foods, products, vehicles you have in your home
            right now have no recalls? What about the future?
          </p>
          <p>
            Recall Monitor is an affordable and secure way to keep on top of
            recalls, and keep yourself and your family safe.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setWhyOpen(false)}>Close</Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

export default WhySubscribeModal
